import { stateGetters, stateSetters } from '@/store/store-utils'
import { GAMES_FEED, GAMES_FEED_NEW } from '@/utils/constants/socket-events'

const defaultState = {
  feed: [],
  paused: false,
}

export default {
  name: 'winfeed',
  namespaced: true,
  state: () => defaultState,
  getters: stateGetters(defaultState),
  mutations: {
    ...stateSetters(defaultState),
    addToFeed(state, win) {
      if (state.feed.length >= 20) {
        state.feed.pop()
      }

      state.feed.unshift(win)
    },
  },
  actions: {
    [`SOCKET_${GAMES_FEED}`]({ commit, rootGetters }, feed) {
      commit('setFeed', feed)
    },
    [`SOCKET_${GAMES_FEED_NEW}`]({ commit, rootGetters }, win) {
      if (rootGetters.paused) return

      const data = { ...win }

      // dont wreck user's device
      if (!rootGetters.windowVisible && !rootGetters.userActive) return

      if (data.gameInfo?.item) {
        const { item } = data.gameInfo
        const itemdb = rootGetters['items/items']
        if (!itemdb) return

        data.gameInfo.item = { name: item, ...itemdb[item] }
      }

      commit('addToFeed', data)
    },
  },
}
